module.exports = __webpack_public_path__ + "img/09.a4c1cd6b.png";